import { render, staticRenderFns } from "./OrderJfdk.vue?vue&type=template&id=2779fa0e&scoped=true&"
import script from "./OrderJfdk.vue?vue&type=script&lang=js&"
export * from "./OrderJfdk.vue?vue&type=script&lang=js&"
import style0 from "./OrderJfdk.vue?vue&type=style&index=0&id=2779fa0e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2779fa0e",
  null
  
)

export default component.exports